/** @format */

import React from "react";
import { useAuth } from "../context/AuthContext";
import Home from "../pages/Home";

function PrivateRoute({ children, ...rest }) {
  const { currentUser } = useAuth();

  return currentUser ? children : <Home />;
}

export default PrivateRoute;
